import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ro from '../lang/ro.json'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import validationMessagesRO from 'vee-validate/dist/locale/ro'
import validationMessagesEN from 'vee-validate/dist/locale/en'
import validationMessagesDE from 'vee-validate/dist/locale/de'

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'ro', // set locale
  fallbackLocale: 'ro',
  messages: { ro } // set locale messages
})

Vue.use(VeeValidate, {
  // i18nRootKey: 'validations', // customize the root path for validation messages.
  i18n,
  dictionary: {
    ro: validationMessagesRO,
    en: validationMessagesEN,
    de: validationMessagesDE
  }
})

const loadedLanguages = ['ro'] // our default language that is preloaded

function setI18nLanguage (lang) {
  window.localStorage.setItem('language', lang)
  i18n.locale = lang
  // axios.defaults.headers.common['Accept-Language'] = lang
  axios.defaults.headers.common['X-localization'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `../lang/${lang}.json`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default || msgs)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}
